import React, { useState } from 'react';
import { Icon } from 'antd-mobile';

import '../index.css';

/* 统计展示 */
function Statistic(props) {
    const { title, data, unit, renderData, compareData, style } = props;

    const DefaultCompareContent = ({ compareProps }) => {
        let data = compareProps.data;
        let beforeData = compareProps.beforeData;
        if (compareProps.renderData) {
            data = compareProps.renderData(compareProps.data);
            beforeData = compareProps.renderData(compareProps.beforeData);
        } else if (renderData) {
            data = renderData(compareProps.data);
            beforeData = renderData(compareProps.beforeData);
        }
        return <div className="little-description p-8-0">
            <div>{`本周期：${data} ${compareProps.unit || unit || ""}`}</div>
            <div>{`上周期：${beforeData}  ${compareProps.unit || unit || ""}`}</div>
        </div>
    }

    const renderCompareData = (item) => {
        if (item.beforeData === undefined) {
            return <span className="text-default" style={{ marginLeft: '20px' }}>
                {`${item.renderData ? item.renderData(item.data) : (renderData ? renderData(item.data) : item.data)} ${item.unit || unit || ""}`}
            </span>
        }
        const [visible, setVisible] = useState(false);
        const textColor = item.data >= item.beforeData ? "green" : "red";
        const iconType = item.data >= item.beforeData ? "up" : "down";
        return <span className="text-default">
            <span onClick={() => setVisible(!visible)} style={{ color: textColor }}>
                <Icon type={iconType} size="xxs" style={{ marginRight: '5px' }} />
                {`${item.renderData ? item.renderData(item.data) : (renderData ? renderData(item.data) : item.data)} ${item.unit || unit || ""}`}
            </span>
            {visible ? (item.compareContent ? item.compareContent : <DefaultCompareContent compareProps={item} />) : null}
        </span>
    }

    return <div className="statistic-content" style={style}>
        <div className="little-description">{title}</div>
        <div className="statistic-data">{`${renderData ? renderData(data) : data} ${unit || ""}`}</div>
        <table id="description-table" >
            <tbody>
                {compareData.map((item, index) => (
                    <tr key={index}>
                        <td className="little-description" style={{ width: item.labelWidth || '30%', background: '#fff' }}>{item.name}</td>
                        <td style={{ width: item.valueWidth || '70%', background: '#fff' }}>{renderCompareData(item)}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    </div>
}
export default Statistic